import React, { useMemo } from 'react';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { RMSIconButton } from '../../../buttons';

const useActionColumn = (actions) => {
  return useMemo(
    () => ({
      field: 'actions',
      headerName: 'Actions',
      fixed: 'right',
      minWidth: 150,
      sortable: false,
      filterable: false,
      hideable: false,
      align: 'center',
      headerAlign: 'center',
      disableColumnMenu: true,

      renderCell: (params) => (
        <div className="common-data-grid-action-buttons">
          {actions?.edit?.visible && (
            <RMSIconButton
              tooltip="Edit"
              icon={<EditIcon />}
              size="small"
              disabled={actions.edit.disabled}
              onClick={(e) => {
                e.stopPropagation();
                actions.edit.onClick?.(params.row);
              }}
            />
          )}

          {actions?.delete?.visible && (
            <RMSIconButton
              tooltip="Delete"
              icon={<DeleteIcon />}
              size="small"
              disabled={actions.delete.disabled}
              className="delete-icon"
              onClick={(e) => {
                e.stopPropagation();
                actions.delete.onClick?.(params.row);
              }}
            />
          )}

          {actions?.custom
            ?.filter((action) => action.visible !== false)
            .map((action, index) => (
              <RMSIconButton
                key={index}
                tooltip={action.tooltip}
                icon={action.icon}
                size="small"
                disabled={action.disabled}
                onClick={(e) => {
                  e.stopPropagation();
                  action.onClick?.(params.row);
                }}
              />
            ))}
        </div>
      ),
    }),
    [actions]
  );
};

export default useActionColumn;
